module.exports = __webpack_public_path__ + "static/media/Professionals.968ececc.png";